import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'collaboAdminUserIds'>,
  Pick<ReqCreateOrUpdateChallenge, 'collaboAdminUserIds'>
> = ({ collaboAdminUserIds }) => {
  return {
    collaboAdminUserIds,
  };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'collaboAdminUserIds'>,
  Pick<ChallengeFormType, 'collaboAdminUserIds'>
> = ({ collaboAdminUserIds }) => {
  return {
    collaboAdminUserIds,
  };
};
